import { useEffect, useRef } from 'react';
import { useInView } from 'react-intersection-observer';

interface UseInfiniteScrollProps {
  hasMore: boolean;
  loading: boolean;
  onLoadMore: () => void;
}

export const useInfiniteScroll = ({
  hasMore,
  loading,
  onLoadMore,
}: UseInfiniteScrollProps) => {
  const { ref, inView } = useInView({
    threshold: 0.1,
    triggerOnce: false,
  });

  const isLoadingRef = useRef(false);

  useEffect(() => {
    if (loading) {
      isLoadingRef.current = true;
    } else {
      const timeout = setTimeout(() => {
        isLoadingRef.current = false;
      }, 100);

      return () => clearTimeout(timeout);
    }
  }, [loading]);

  useEffect(() => {
    if (inView && hasMore && !loading && !isLoadingRef.current) {
      isLoadingRef.current = true;
      onLoadMore();
    }
  }, [inView, hasMore, loading, onLoadMore]);

  return ref;
};
